import { SEND_SHARE_LINK_CHAT_MESSAGE } from 'root/src/shared/descriptions/endpoints/endpointIds';
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
export default {
    [SEND_SHARE_LINK_CHAT_MESSAGE]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
        isLowSpec: true,
    },
};
